export function buildAssignedTrainingRequest({
  assignmentId,
  questionCount
}) {
  return {
    mode: 'TRAINING_MODE',
    limit: questionCount,
    excludeAnswered: 'false',
    assignedTestId: assignmentId
  }
}
